import { z } from "zod";

import { cartonClosingSchema, cartonClosingStatusSchema } from "../packaging-solution/carton-closing";
import { mediaSchema } from "../packaging-solution/packaging-component/packaging-component-base";
import { locationSchema } from "../packaging-solution/location";

import { auditEventBaseSchema } from "./audit-event-base";

export const closingAuditDataSchema = z.object({
	cartons: z
		.array(
			z.object({
				id: z.string(),
				alias: z.string().nullish(),
				identifier: z.string().nullish(),
				usedProductionOption: z
					.object({
						productionData: z.object({ barcode: z.string().nullish() }).nullish(),
					})
					.nullish(),
				media: mediaSchema.optional(),
				closing: cartonClosingSchema.nullish(),
			}),
		)
		.nullish(),
	location: locationSchema.nullish(),
	closingData: z
		.object({
			upstreamCompletedDateUTC: z.string().nullish(),
			downstreamCompletedDateUTC: z.string().nullish(),
		})
		.nullish(),
});

export const auditEventClosingSchema = auditEventBaseSchema.extend({
	auditType: cartonClosingStatusSchema,
	data: closingAuditDataSchema.nullish(),
});

export type AuditEventClosing = z.infer<typeof auditEventClosingSchema>;
